function l(n, t, a) {
  if (typeof t.value != "function")
    return;
  function c(e) {
    if (!a.context)
      return;
    const o = e.path || e.composedPath && e.composedPath();
    o && o.length > 0 && o.unshift(e.target), !n.contains(e.target) && n.__PendoOnClickAway__.callback(e);
  }
  n.__PendoOnClickAway__ = {
    handler: c,
    callback: t.value
  }, document.body.addEventListener("click", c);
}
function u(n, t) {
  typeof t.value == "function" && (n.__PendoOnClickAway__.callback = t.value);
}
function _(n) {
  document.body.removeEventListener("click", n.__PendoOnClickAway__.handler), delete n.__PendoOnClickAway__;
}
const d = {
  beforeMount: l,
  updated: u,
  unmounted: _
};
export {
  d as PendoOnClickAway,
  d as default
};
//# sourceMappingURL=pendo-on-click-away.js.map
